<template>
    <div class="formItem" :class="{'formError' : error}">
        <label v-if="!onlyField">{{ label }}
            <span v-if="subLabel"> ({{ subLabel }})</span>
        </label>
        <small class="unit" v-if="suffix">{{suffix}}</small>
        <v-text-field
                v-if="fieldType === 'craft\\fields\\Number'"
                type="number"
                solo
                flat
                hide-details
                class="sr-input"
                :label="label"
                :value="value"
                @input="$emit('input', $event)"
                :disabled="loading || readonly"
                :readonly="loading || readonly"
        ></v-text-field>
        <v-text-field
                v-else
                solo
                flat
                hide-details
                :placeholder="placeholder"
                class="sr-input"
                :label="label"
                :value="value"
                @input="$emit('input', $event)"
                :disabled="loading || readonly"
                :readonly="loading || readonly"
        ></v-text-field>
    </div>
</template>

<script>
  export default {
    props: {
      suffix: {
        type: String,
        default: ''
      },
      fieldType: {
        type: String,
        default: ''
      },
      onlyField: {
        type: Boolean,
        default: false
      },
      error: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      subLabel: {
        type: String,
        default: ''
      },
      value: {
        type: [String, Number],
        default: null
      }
    }
  }
</script>

<style scoped>

</style>
